// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import {
	type ChannelDeleteModalProps,
	deleteChannel,
	getChannelDeleteInfo,
} from '@app/features/channel/utils/ChannelDeleteModalUtils';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useState} from 'react';
export const ChannelDeleteModal = observer(({channelId}: ChannelDeleteModalProps) => {
	const deleteInfo = getChannelDeleteInfo(channelId);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const onSubmit = async () => {
		if (!deleteInfo) return;
		setIsSubmitting(true);
		try {
			await deleteChannel(channelId);
		} finally {
			setIsSubmitting(false);
		}
	};
	if (!deleteInfo) return null;
	const {channel, isCategory, title, confirmText} = deleteInfo;
	return (
		<Modal.Root size="small" centered>
			<Modal.Header title={title} />
			<Modal.Content>
				<Modal.ContentLayout>
					<Modal.Description>
						{isCategory ? (
							<Trans>
								Are you sure you want to delete <strong>{channel.name}</strong>? This cannot be undone.
							</Trans>
						) : (
							<Trans>
								Are you sure you want to delete <strong>{channel.name}</strong>? This cannot be undone.
							</Trans>
						)}
					</Modal.Description>
				</Modal.ContentLayout>
			</Modal.Content>
			<Modal.Footer>
				<Button onClick={ModalCommands.pop} variant="secondary">
					<Trans>Cancel</Trans>
				</Button>
				<Button onClick={onSubmit} submitting={isSubmitting} variant="danger-primary">
					<Trans>{confirmText}</Trans>
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
});
